import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getBillRates } from 'api/billRates/getBillRates'
import { billRatesKeyWithParams } from './keys'

export const useBillRatesQuery = (
  request: Parameters<typeof getBillRates>[0]
) => {
  return useQuery({
    queryKey: billRatesKeyWithParams([
      request.page,
      request.pageSize,
      request.companyId ?? 'all',
      request.positionId ?? 'all',
      request.includeDeleted ? 'deleted' : 'active',
    ]),
    queryFn: () => getBillRates(request),
    placeholderData: keepPreviousData,
  })
}
